import { useState, useEffect } from 'react';
import useAuth from './useAuth';
import { listNews } from '../firebase/admin';

// Loads published community-news articles for the signed-in member. Returns
//   { articles, status }  where status is loading | signedOut | error | ready.
// Shared by the home News section and the full /news page (they differ only in
// `max` and how much of the result they display). Mirrors useCalendarEvents.
export default function useNews({ max } = {}) {
  const user = useAuth(); // undefined = resolving, null = signed out, User = signed in
  const [articles, setArticles] = useState([]);
  const [status, setStatus] = useState('loading');

  useEffect(() => {
    if (user === undefined) return undefined; // auth still resolving
    if (!user) {
      setArticles([]);
      setStatus('signedOut');
      return undefined;
    }
    let cancelled = false;
    setStatus('loading');
    listNews({ max })
      .then((list) => {
        if (cancelled) return;
        setArticles(list);
        setStatus('ready');
      })
      .catch(() => {
        if (!cancelled) setStatus('error');
      });
    return () => {
      cancelled = true;
    };
  }, [user, max]);

  return { articles, status };
}
